import { render, staticRenderFns } from "./CityEdit.vue?vue&type=template&id=2ff52e91&scoped=true"
import script from "./CityEdit.vue?vue&type=script&lang=js"
export * from "./CityEdit.vue?vue&type=script&lang=js"
import style0 from "./CityEdit.vue?vue&type=style&index=0&id=2ff52e91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff52e91",
  null
  
)

export default component.exports